import * as React from 'react'
import { Icon } from '../../atoms/icon'
import { Color, Size } from '../../../constants/app.constant'
import webShare, { WebShareInterface } from 'react-web-share-api'

export interface OwnProps {
  style: object
}

const ShareButton: React.StatelessComponent<WebShareInterface & OwnProps> = ({
  share,
  isSupported,
  style,
}) =>
  isSupported ? (
    <button onClick={share} style={style}>
      <Icon.Share size={`${Size.LARGE}px`} color={Color.DARK_GRAY} />
    </button>
  ) : null

export default webShare<OwnProps>()(ShareButton)



// WEBPACK FOOTER //
// ./src/components/pages/report/share_button.tsx